@if (typeOfShopsPage !== shopsListTypes.favShops) {
  <app-search-bar-with-filters
    [searchBarText]="'Поиск по магазинам'"
    [isNeedFiltersButton]="typeOfShopsPage === shopsListTypes.allShops"
    [isFavoriteOption]="false"
  ></app-search-bar-with-filters>
}

@if (shops$ | async; as shopsList) {
  <app-pagination-container
    [listName]="listNameShops"
    [clearListAction]="clearShopsAction"
    [isLoading$]="isLoading$"
    [hideLoading]="isRefreshing"
    [paginationData]="shops$ | async"
    [isAllLoaded]="
      typeOfShopsPage === shopsListTypes.favShops ? true : (allShopDataFetched$ | async)
    "
    (emitScrolling)="getShops()"
    [noDataText]="
      typeOfShopsPage === shopsListTypes.favShops ? 'Список избранного пуст' : noDataText
    "
  >
    <div class="shops-list">
      @for (shop of shopsList; track trackByFn($index, shop)) {
        <app-shop-card
          [shop]="shop"
          (emitShopFavoriteState)="handlerFavoriteState($event)"
          [id]="shop.id"
        ></app-shop-card>
      }
    </div>
  </app-pagination-container>
}
